// extracted by mini-css-extract-plugin
export default {"cell":"ApprovalSignatureCell_cell__5jWja","readOnly":"ApprovalSignatureCell_readOnly__weP5y"};